import { Box, Container, Divider, Typography } from '@mui/material'
import React from 'react'
import AdminPaymentsLast from './AdminPaymentsLast';
import AdminCounters from './AdminCounters';

export default function AdminStats() {

    return (
        <Container maxWidth='lg' sx={{ minHeight: '100vh', pb: '120px' }}>
            <AdminCounters />
            <AdminPaymentsLast />
        </Container>
    )
}
